import React, { useMemo, useState, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import UploaderAllCM from "../Create/CreateContent/Uploader/UploaderAllCM";

// Register image resize module
Quill.register("modules/imageResize", ImageResize);

export default function RichTextEditor({
  value,
  onChange,
  placeholder = "Write something...",deleteStatus,onDelete
}) {
  const [openUploaderPopUp, setOpenUploaderPopUp] = useState(false);
  const [currentFileObject, setCurrentFileObject] = useState(null);
  const [isHtmlMode, setIsHtmlMode] = useState(false);
  const [htmlContent, setHtmlContent] = useState(value || "");
  const quillRef = useRef();

// 🧩 Extend Quill's built-in Image format
const ImageFormat = Quill.import("formats/image");

class CustomImage extends ImageFormat {
  static create(value) {
    const node = super.create(value);

    // Handle when value is object or string
    if (typeof value === "object") {
      node.setAttribute("src", value.src);
      if (value["data-s3key"]) node.setAttribute("data-s3key", value["data-s3key"]);
      if (value.width) node.setAttribute("width", value.width);
      if (value.style) node.setAttribute("style", value.style);
    } else {
      node.setAttribute("src", value);
    }

    return node;
  }

  static formats(domNode) {
    // Return custom attributes so Quill knows about them
    return {
      src: domNode.getAttribute("src"),
      "data-s3key": domNode.getAttribute("data-s3key"),
      width: domNode.getAttribute("width"),
      style: domNode.getAttribute("style"),
    };
  }

  format(name, value) {
    if (name === "data-s3key" || name === "width" || name === "style") {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      super.format(name, value);
    }
  }

  static value(domNode) {
    return {
      src: domNode.getAttribute("src"),
      "data-s3key": domNode.getAttribute("data-s3key"),
      width: domNode.getAttribute("width"),
      style: domNode.getAttribute("style"),
    };
  }
}

// ✅ Register the new image format
Quill.register("formats/image", CustomImage);
  // 🧩 Image button handler (open uploader popup)
  const handleImageButtonClick = () => setOpenUploaderPopUp(true);

  // 🧠 When a file is selected/uploaded
 const handleSetCurrentFileObject = (fileObj) => {
  setCurrentFileObject(fileObj);

  if (fileObj?.fileUrl && fileObj?.file_s3_key) {
    const quill = quillRef.current?.getEditor();
    const range = quill?.getSelection(true);

    // Insert image normally first
    quill?.insertEmbed(range?.index || 0, 'image', fileObj.fileUrl);
    quill?.setSelection((range?.index || 0) + 1);

    // Add the S3 key as a custom attribute after insertion
    const [img] = quill.root.querySelectorAll(`img[src="${fileObj.fileUrl}"]`);
    if (img) {
      img.setAttribute('data-s3key', fileObj.file_s3_key);
       img.setAttribute('width', "340px");
    }
  }

  setOpenUploaderPopUp(false);
};


  // 🪶 Toggle between modes
const toggleMode = () => {
  const quill = quillRef.current?.getEditor?.();

  if (!isHtmlMode) {
    const currentHtml = quill ? quill.root.innerHTML : value || "";
    setHtmlContent(currentHtml);
    setIsHtmlMode(true);
  } else {
    setIsHtmlMode(false);
    setTimeout(() => {
      const editor = quillRef.current?.getEditor?.();
      if (editor) {
        editor.root.innerHTML = htmlContent;
        onChange(htmlContent);
      }
    }, 0); // wait for re-render
  }
};


  // Update both states in sync
  const handleHtmlChange = (e) => {
    const newHtml = e.target.value;
    setHtmlContent(newHtml);
    onChange(newHtml);
  };

 const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: [] }, { size: [] }],
          ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
          [{ color: [] }, { background: [] }],
          [{ align: [] }, { list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
          ["link", "image"],
          ["clean"]
        ],
        handlers: {
          image: handleImageButtonClick,
        },
      },
      clipboard: {
        // Match visual line breaks exactly
        matchVisual: false,
      },
      imageResize: {
        parchment: Quill.import("parchment"),
        modules: ["Resize", "DisplaySize", "Toolbar"],
      },
    }),
    []
  );

  const formats = [
    // Text styles
    "header", "font", "size",
    "bold", "italic", "underline", "strike", "blockquote", "code-block",
    "script", // sub/superscript

    // Colors
    "color", "background",

    // Alignment & structure
    "align", "list", "bullet", "indent", "direction",

    // Media
    "link", "image", "video",

    // Custom attributes
    "width", "height", "style", "data-s3key"
  ];

  return (
    <>
      <style>{`
        .custom-quill-container {
          background: #fff;margin-top:30px;
          border-radius: 12px;
          border: 3px solid rgba(144, 202, 249,1);
          box-shadow: 0 2px 6px rgba(0,0,0,0.05);
          
          position: relative;
        }

        .ql-toolbar.ql-snow {
          background: #f8f9fb;
          border: none;
          border-bottom: 3px solid rgba(144, 202, 249,1);
          border-radius: 12px 12px 0 0;
          padding: 8px 10px;
        }

        .ql-container.ql-snow {
          border: none;
          border-radius: 0 0 12px 12px;
          font-family: "Inter", "Roboto", sans-serif;
          font-size: 15px;
          min-height: 180px;
          color: #333;
        }

        textarea.html-editor {
          width: 89%; padding: 15px;margin:5px;
          min-height: 200px;padding-top:10px;
          border: none;
          outline: none;
          resize: vertical;
         
          font-family: monospace;
          font-size: 14px;
          background: #ffffff;
          color: #222;
        }
.all-btns-outer { position: absolute;
          top: -30px;
          right: 10px; display:flex;justify-content:right;gap:10px}
        .toggle-btn {
         
          background: rgba(144, 202, 249,1);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 13px;
          padding: 5px 10px;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .toggle-btn:hover {
          background: rgba(144, 202, 249,0.81);
        }
      `}</style>

      <div className="custom-quill-container">
        <div className="all-btns-outer">
        <button className="toggle-btn" onClick={toggleMode}>
          {isHtmlMode ? "View Text" : "View HTML"}
        </button> {deleteStatus?<button className="toggle-btn" onClick={onDelete}>
          Delete
        </button>:""} </div>

        {openUploaderPopUp && (
          <UploaderAllCM
            fileTypeObject={[{ title: "Images", value: "image" }]}
            selectedFileObject={currentFileObject}
            currentFileObject={currentFileObject}
            setCurrentFileObject={handleSetCurrentFileObject}
            setCloseUploaderPopUp={() => setOpenUploaderPopUp(false)}
          />
        )}

        {!isHtmlMode ? (
          <ReactQuill
            ref={quillRef}
            theme="snow"
            modules={modules}
            formats={formats}
            value={(value)}
            onChange={onChange}
            placeholder={placeholder}
          />
        ) : (
          <textarea
            className="html-editor"
            value={htmlContent}
            onChange={handleHtmlChange}
          />
        )}
      </div>
    </>
  );
}
